import { TenantDetails } from '@feature/tenants/index';
import { Action } from '@ngrx/store';

export const GET = '[TenantDetails] Get';
export const GET_COMPLETE = '[TenantDetails] Get Complete'
export const CLEAR = '[TenantDetails] Clear';

export class Get implements Action {
  readonly type = GET;
  constructor(public payload: number) { }
}

export class GetComplete implements Action {
  readonly type = GET_COMPLETE;
  constructor(public payload: TenantDetails) { }
}

export class Clear implements Action {
  readonly type = CLEAR;
  constructor() { }
}

export type Actions =
  Get |
  GetComplete |
  Clear;
